import Env from '../base/env'
import Channels from '../base/channels'
import Component from 'gia/Component';
import gsap from 'gsap'
import Splide from '@splidejs/splide';


export default class Features extends Component
{


  mount() {
    //? DOM
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.slideshowVisuals = this.DOM.view.querySelector('.js-slideshow-visuals')
    this.DOM.slideshowTexts = this.DOM.view.querySelector('.js-slideshow-texts')
    this.DOM.btnPrev = this.DOM.view.querySelector('.js-prev')
    this.DOM.btnNext = this.DOM.view.querySelector('.js-next')


    //? Vars
   this.VARS = {}
    //? Fns

   this.makeSlideshow()

    this.funcResize = this.resize.bind(this)
    Channels.on('window::smartresize',this.funcResize)
  }

  makeSlideshow()
  {

    this.slideshowVisuals = new Splide(this.DOM.slideshowVisuals , {
      arrows: false,
      gap:36,
      interval: 7000,
      height:'44vh',
      autoWidth:true,
      padding:{ left:10, right:10 },
      pauseOnFocus:false,
      pauseOnHover:false,
      pagination:false,
      focus:'center',
      perPage:1,
      perMove:1,
      rewind:true,

      speed: 700,
      type: 'slide',
      breakpoints: {
        640: {
          arrows:false,
          height:'24vh',
          pagination:true,
          gap: 16,
          padding:{ left:32, right:32 },
          perPage:1
        }
      },
    })

    this.slideshowVisuals.on('mounted',()=>{
      const viewport = Env.framework.toolbox.getViewport()
      const posX = viewport.width - this.DOM.slideshowVisuals.querySelectorAll('.splide__slide')[0].querySelector('img').getBoundingClientRect().width
      gsap.set(this.DOM.slideshowVisuals.querySelector('.splide__track'), { paddingLeft: posX / 2, paddingRight:posX / 2})
    })

    this.slideshowVisuals.on('move',(newIndex,prevIndex,destIndex)=>{
      if(typeof this.slideshowTexts != 'undefined') {
        this.slideshowTexts.go(newIndex)
      }

    })

    this.slideshowVisuals.mount()


    this.slideshowTexts = new Splide(this.DOM.slideshowTexts , {
      arrows: false,
      gap:36,
      pauseOnFocus:false,
      pauseOnHover:false,
      perPage:1,
      perMove:1,
      rewind:true,
      rewindByDrag:true,
      speed: 700,
      type: 'fade',
      pagination:false,
      breakpoints: {
        640: {
          arrows:false,
          pagination:false,
          gap: 24,
          perPage:1
        }
      },
    })

    this.slideshowTexts.on('move',(e)=>{
      if(typeof this.slideshowVisuals != 'undefined') {
        this.slideshowVisuals.go(e)
      }
    })
    this.slideshowTexts.mount()

    this.DOM.btnPrev.addEventListener('click',()=>{
      this.slideshowTexts.go('-')
    })

    this.DOM.btnNext.addEventListener('click',()=>{
      this.slideshowTexts.go('+')
    })

  }

  resize()
  {
    // this.slideshowVisuals.destroy()
    // this.slideshowTexts.destroy()
    // setTimeout(() => {
    //   this.makeSlideshow()
    // }, 100);

  }

  unmount()
  {
    this.slideshowVisuals.destroy(true)
    this.slideshowTexts.destroy(true)
    Channels.removeListener('window::smartresize',this.funcResize)
  }
}
